module.exports = __webpack_public_path__ + "img/main_img_rep_dem.1c5d3e44.jpeg";